import patientInfomationCenter from "./modules/filterCondition/patientInfomationCenter"
import Vue from 'vue';
import Vuex from 'vuex';
import schemeList from "./modules/filterCondition/schemeList";
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        patientInfomationCenter: patientInfomationCenter,  // 访问路径: this.$store.state.patientInfomationCenter
        schemeList: schemeList,// 访问路径: this.$store.state.schemeList
    }
})